export default __webpack_public_path__ + "static/cz-ad61a85f5ff465b74d1dee21db5995f5.svg";